module.exports = __webpack_public_path__ + "static/rice.fdaf360a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/rice.png
// module id = 2196
// module chunks = 61762850755587